import { Component, NgZone} from '@angular/core';
import { CalendarService } from 'src/app/_provider/calendar/calendar.service';
import dayjs from '../../_utils/dayjs.config';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { Employee } from 'src/app/_interfaces/employee';
import { CalendarAppointment } from './AppointmentItem';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/_provider/general.service';
import { ResizeManagerService, ScreenSize } from 'src/app/_provider/resize-manager.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.page.html',
    styleUrls: ['./calendar.page.scss'],
    standalone: false
})
export class CalendarPage {

  public selectedSegment: string = "day"
  public showSidebar: boolean = true

  public selectedDates: dayjs.Dayjs[] = [dayjs()] 
  public selectedEmployees: Employee[] = []

  public appointments: CalendarAppointment[] = []

  public mobileVisibleDate: dayjs.Dayjs = dayjs()

  private cbRouteSub: Subscription
  private screenSizeSub: Subscription

  public isModal: boolean = false

  constructor(
    public calendarService: CalendarService, 
    private ngZone: NgZone,
    public generalSrv: GeneralService,
    private modalCtrl: ModalController,
    public resizeManager: ResizeManagerService,
    private platform: Platform,
    private breadcrumbSrv: BreadcumbService,
    private navCtrl: NavController
  ){ 
    
    if(window.matchMedia("(max-width: 1050px)").matches || this.platform.is("capacitor")) 
      this.navCtrl.navigateRoot("tabs/calendar-mobile")

    //Default Breadcrumb setzen
    this.cbRouteSub = this.breadcrumbSrv.routeChange().subscribe((route: string)=>{      
      if(route == "/tabs/calendar") this.breadcrumbSrv.breadcrumbs = [{ name: "Kalender"}]
    }) 

  }

  ngOnInit() {
    this.screenSizeSub = this.resizeManager.screenSizeChanged.subscribe(async () => {
      if(this.breadcrumbSrv.activeRoute == "/tabs/calendar" && this.resizeManager.isPortrait) await this.navCtrl.navigateRoot("tabs/calendar-mobile")
    })
  }


  ngOnDestroy(){
    this.cbRouteSub?.unsubscribe()
    this.screenSizeSub?.unsubscribe()
  }

  public async closeModal(){
    await this.modalCtrl.dismiss()
  }

  public async datesChanged(dates: dayjs.Dayjs[]){
    this.ngZone.run(async () => {
      this.selectedDates = dates
      await this.loadAppointments()
    })
  }

  public async employeesChanged(employees: Employee[]){
    this.selectedEmployees = employees
    await this.loadAppointments()
  }

  public async loadAppointments(){
    this.appointments = []
    if(this.selectedDates.length == 0 || this.selectedEmployees.length == 0) return
    const startDate: Date = this.selectedDates[0].startOf("day").toDate()
    const endDate: Date = this.selectedDates[this.selectedDates.length - 1].endOf("day").toDate()
    const employeeIds: number[] = this.selectedEmployees.map(e => e.id)
    this.appointments = await this.calendarService.getAppointments(startDate, endDate, employeeIds)
  }



}
